<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo grupo:
    </h2>

    <GroupForm
      @save="save"
      @cancel="cancel"
      :taxLevels="taxLevels"
      :taxTypes="taxTypes"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import GroupForm from '@/components/GroupForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    GroupForm
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    }
  },
  methods: {
    ...mapActions('groups', ['saveItem']),
    ...mapActions('taxLevels', { loadTaxLevels: 'loadItems' }),
    ...mapActions('taxTypes', { loadTaxTypes: 'loadItems' }),
    save ({ data }) {
      saveItem(data, 'MyCompanyGroups', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyGroups' })
    }
  },
  created () {
    Promise.all([
      this.loadTaxLevels(),
      this.loadTaxTypes()
    ])
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
